import { action, makeObservable, observable } from 'mobx';

interface Dashboard {
  balanceTodayCurrency: string;
  balanceTodayValue: string;
  productionTodayUnit: string;
  productionTodayValue: number;
}

export type Direction = 'in' | 'out';

interface DeviceDetails {
  energyDirection: Direction;
  energyFlowUnit: string;
  energyFlowValue: string;
}
export interface Devices {
  battery: DeviceDetails;
  network: DeviceDetails;
  solar: DeviceDetails;
}

class DashboardStore {
  @observable dashboard: Nullable<Dashboard> = null;
  @observable devices: Nullable<Devices> = null;

  private convertDeviceData = (data: SimpleObject) => {
    const convertedData: SimpleObject = {};
    data.forEach((entry: SimpleObject) => {
      const { icon, ...rest } = entry;
      convertedData[icon] = {
        energyDirection: rest.energy_direction,
        energyFlowUnit: rest.energy_flow_unit,
        energyFlowValue: rest.energy_flow_value,
      };
    });
    return convertedData;
  }

  @action setDashboardData = (data: SimpleObject) => {
    this.dashboard = {
      balanceTodayCurrency: data.dashboard.balance_today_currency,
      balanceTodayValue: data.dashboard.balance_today_value,
      productionTodayUnit: data.dashboard.production_today_unit,
      productionTodayValue: data.dashboard.production_today_value
    }
    this.devices = this.convertDeviceData(data.devices) as Devices;
  };

  constructor() {
    makeObservable(this);
  }
}

export default DashboardStore;
